import Axios from "axios";
import {
} from "@/store/mutation-types";

import { saveUpdateAttendanceUpload } from "@/store/api";

const state = {
    getAttendanceReconciliationList: [],
    getEditingAttendanceReconciliation: null,
};

const getters = {
};

const mutations = {
};

const actions = {
    
    saveUpdateAttendanceUpload({ commit }, data) {
        commit("SET_LOADING", {color: "primary"});
        return new Promise((resolve, reject) => {
            Axios.post(saveUpdateAttendanceUpload, data, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                })
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
